import React, { useEffect, useState } from "react";
import { Select, Spin } from "antd";
import useRequest from "../../hooks/useRequest";
import { ShowToast, Severty } from "../../helper/toast";
import apiPath from "../../constants/apiPath";
const { Option } = Select;

const VehicleSelect = ({ manufacturerId, value, onChange, disabled = false }) => {

  const { request } = useRequest();
  const [vehicleList, setVehicleList] = useState([]);
  const [loading, setLoading] = useState(false);
  
  const fetchVehicles = async () => {
    
    if (!manufacturerId) {
      setVehicleList([]);
      return;
    }

    setLoading(true);
    request({
      url: `${apiPath.commonVehicle}?manufacturer_id=${manufacturerId}`,
      method: "GET",
      onSuccess: (res) => {
        const vehicles = res?.data?.data || [];
        setVehicleList(vehicles);
        setLoading(false);
      },
      onError: (err) => {
        setLoading(false);
        ShowToast(err?.response?.data?.message || "Failed to load manufacturers", Severty.ERROR);
      },
    });
  }

  useEffect(() => {
    fetchVehicles();
  }, [manufacturerId]);

  return (
    <Spin spinning={loading} tip="Loading vehicles..." size="small">
      <Select
        showSearch
        allowClear
        placeholder={manufacturerId ? "Select vehicles" : "Select manufacturer first"}
        optionFilterProp="children"
        value={value}
        onChange={(val) => onChange?.(val)}
        disabled={!manufacturerId || disabled}
        loading={loading}
        filterOption={(input, option) =>
          option?.children?.toLowerCase().includes(input.toLowerCase())
        }
        className="w-full"
      >
        {vehicleList?.map((item) => (
          <Option key={item._id} value={item._id}>
            {item.en_name}
          </Option>
        ))}
      </Select>
    </Spin>
  );
};

export default VehicleSelect;
